<template>
  <div>
    <div class="tw-py-2 sm:tw-py-0 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-if="isEditing">
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light tw-flex tw-items-center">Phone Number</dt>
      <div class="tw-flex tw-items-center sm:tw-pt-4 sm:tw-col-span-2">
        <base-form ref="form" class="tw-w-full ">
          <base-phone-number-input placeholder="Enter Phone Number" v-model="mobile" :e164.sync="e164" :rules="rules" required />
        </base-form>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse sm:tw-items-center">
        <base-button size="sm" @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button size="sm" type="flat" @click="isEditing = false" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">Cancel</base-button>
      </div>
    </div>
    <div class="tw-py-2 sm:tw-py-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-else>
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light">Phone Number</dt>
      <dd class="tw-mt-1 tw-flex tw-text-sm tw-text-gray-900 sm:tw-mt-0 sm:tw-col-span-3 tw-mb-0">
        <span class="tw-flex-grow tw-flex tw-items-center">
          <span class="tw-mr-1.5"><base-phone-number-field :isHyperlinkActive="false" :value="user.mobile"/></span>
        </span>
        <span class="tw-ml-4 tw-flex-shrink-0">
          <base-button type="text" @click="startEditing">Update</base-button>
        </span>
      </dd>
    </div>
    <base-modal ref="confirmationModal">
      <base-card shadow>
        <div class="sm:tw-flex sm:tw-items-start">
          <div
            class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-primary-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw--mt-1.5"
          >
            <mail-icon class="tw-h-6 tw-w-6 tw-text-primary" />
          </div>
          <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
            <h3 class="tw-text-xl tw-font-thin">Phone Number Updated Successfully</h3>
            <div class="tw-mt-2 tw-text-gray-600">
              <p>
                Your phone number has been updated successfully.
              </p>
            </div>
          </div>
        </div>

        <div class="tw-flex tw-justify-end">
          <base-button @click="$refs.confirmationModal.hide()" type="flat">Close</base-button>
        </div>
      </base-card>
    </base-modal>
  </div>
</template>

<script>
import { MailIcon } from "@/assets/svgs";

export default {
  components: {
    MailIcon,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
      isLoading: false,
      isConfirming: false,
      mobile: "",
      e164: "",
      rules: [() => this.e164 !== this.user.mobile || "Must be a new mobile"],
    };
  },
  methods: {
    startEditing() {
      this.mobile = this.user.mobile;
      this.isEditing = true;
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isLoading = true;
        await this.$axios.post(`/users/${this.user.id}/update-phone-number`, {
          phoneNumber: this.e164,
        });
        this.$emit("user-updated", {
          ...this.user,
          mobile: this.e164,
          mobileVerified: false,
        });

        this.$refs.confirmationModal.show();
        this.isEditing = false;
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Issue updating profile",
          message: "We had an issue updating your profile. You may want to try again.",
          error: { message: error.response.data },
        });
      } finally {
        this.isLoading = false;
      }
    },
    async confirm() {
      try {
        this.isConfirming = true;
        await this.$axios.post(`/users/${this.user.id}/mobileverify/send`, { mobile: this.user.mobile });
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "mobile Verification Sent", message: "Please check your mobile to verify" });
      } finally {
        this.isConfirming = false;
      }
    },
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler() {
        this.mobile = this.user.mobile;
      },
    },
  },
};
</script>
